import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import { AuthContext } from "../../AuthProvider";
import useGetCorrosionAlertsData from "../../pages/alerts/hooks/useGetCorrosionAlertsData"
import useGetRemnantLifeAlertsData from "../../pages/alerts/hooks/useGetRemnantLifeAlertsData"
import { toast } from "react-toastify";
import { mapAndJoinArray } from "../../util/helperFunctions";
import { azureFetch } from "../../api/azureFetch";


function useGetNotification(pathname) {
    const [notifications, setNotifications] = useState([]);
    const authContext = useContext(AuthContext);
    console.log("authContext in useGetNotification", authContext);
    const isTokenReady = authContext?.isTokenReady;
    console.log("isTokenReady in useGetNotification", isTokenReady);
    const enableNotifications = (pathname === '/' || pathname === '/home') && isTokenReady;
    const [fetchNewNotifications, setFetchNewNotifications] = useState(false);
    // useEffect(() => {
    //     setLoading(true);
    //     c3request("User", "myUser").then((user) => {
    //         c3request("MemberToPhysicalAsset", "fetch", {
    //             spec: {
    //                 filter: `member == "${user.id}"`,
    //                 include: "this,user.id, user.groups"
    //             }
    //         }).then(MemberToPhysicalAsset => {
    //             if (MemberToPhysicalAsset.count > 0) {
    //                 addData(MemberToPhysicalAsset.objs);
    //                 var targets = MemberToPhysicalAsset.objs.map((x) => x.target.id);
    //                 // Fetching the latest alerts
    //                 Promise.all([
    //                     c3request("CarmaLatestAlert", "fetch", {
    //                         spec: {
    //                             include: include,
    //                             limit: 5,
    //                             filter: `intersects(sensor.site.id,[${mapAndJoinArray(targets)}])`,
    //                             offset: 0,
    //                             order: `descending(meta.created)`,
    //                         },
    //                     }).then((alerts) => {
    //                         if (alerts.objs) {
    //                             return alerts.objs.filter(alert => alert.status === 'NEW');
    //                         }
    //                         return [];
    //                     }),
    //                     c3request("PermasensIdentifierEvent", "fetch", {
    //                         spec: {
    //                             include: include,
    //                             limit: 5,
    //                             filter: `intersects(sensor.site.id,[${mapAndJoinArray(targets)}])`,
    //                             offset: 0,
    //                             order: `descending(meta.created)`,
    //                         },
    //                     }).then((remnentAlerts) => {
    //                         if (remnentAlerts.objs) {
    //                             return remnentAlerts.objs.filter(alert => alert.status === 'NEW');
    //                         }
    //                         return [];
    //                     })
    //                 ]).then(([predictedAlerts, remnantAlerts]) => {
    //                     setNotifications([...predictedAlerts, ...remnantAlerts]);
    //                 })
    //             } else {
    //                 setNotifications([]);
    //             };
    //         }).catch((error) => {
    //             toast.error("Error fetching notifications");
    //             console.error(error);
    //         })
    //     }).finally(() => {
    //         setLoading(false);
    //     });
    // }, [addData, fetchNewNotifications]);

    // Call hooks at the top level
    const { data: corrosionAlerts, loading: corrosionLoading } = useGetCorrosionAlertsData("sensor.excludeFromUI=0 AND status = 'NEW'", 5, 1, "alertStartDate", "DESC", fetchNewNotifications, enableNotifications);
    const { data: remAlerts, loading: remnantLoading } = useGetRemnantLifeAlertsData("sensor.excludeFromUI=0 AND status = 'NEW'", 5, 1, "startDate", "DESC", fetchNewNotifications, enableNotifications);
    console.log("corrosionAlerts", corrosionAlerts);
    console.log("remAlerts", remAlerts);
    useEffect(() => {
        try {
            if (enableNotifications){
                const predictedAlerts = corrosionAlerts?.alertsList?.filter(alert => alert.status === 'NEW') || [];
                predictedAlerts.forEach(alert => { alert.alertTypeUI = 'CR'; });
                const remnantAlerts = remAlerts?.alertsList?.filter(alert => alert.status === 'NEW') || [];
                remnantAlerts.forEach(alert => { alert.alertTypeUI = 'WT'; });
                setNotifications([...predictedAlerts, ...remnantAlerts]);
            }
        } catch (error) {
            toast.error("Error fetching notifications");
            console.error(error);
        }
    
    }, [corrosionAlerts, remAlerts]);


    const markAsRead = async (notificationId, notificationType = 'CR', all = false) => {
        if (notificationType === 'CR'){
            var res = await azureFetch("updateAlertStatus", {
                    alert_ids: [notificationId],
                    status: 'READ'
                })
            if (res.message === "Success" && !all){
                toast.success("Notification marked as read");
                setFetchNewNotifications(!fetchNewNotifications);
            }
                    
        }
        
        if (notificationType === 'WT'){
            var res = await azureFetch("markasREAD", {
                    alert_ids: [notificationId],
                    status: 'READ'
                })
            if (res.message === "Success" && !all){
                toast.success("Notification marked as read");
                setFetchNewNotifications(!fetchNewNotifications);
            }
        }
    }


    const markAllAsRead = async () => {
        for(let notification of notifications){
            await markAsRead(notification.id, notification.alertTypeUI, true);
        }

        toast.success("All notifications marked as read");
        setFetchNewNotifications(!fetchNewNotifications);
        
    }

    const loading = corrosionLoading || remnantLoading;
    console.log(loading)

    // // Function to extract the date from a notification based on its meta.fetchType
    // const extractDate = (notification) => {
    //     if (notification.meta.fetchType === "CarmaLatestAlert") {
    //         return new Date(notification.alertEndDate);
    //     } else if (notification.meta.fetchType === "PermasensIdentifierEvent") {
    //         return new Date(notification.endDate);
    //     }
    //     return new Date(); // Default to current date if none match
    // };

    // // Sort the notifications array
    // notifications.sort((a, b) => {
    //     const dateA = extractDate(a);
    //     const dateB = extractDate(b);
    //     return dateB - dateA; // For ascending order, swap dateB and dateA for descending
    // });

    return { notifications, loading, markAsRead, markAllAsRead };

}

export default useGetNotification;